import script from "./ImportConfigFile.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportConfigFile.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72acd288"]])

export default __exports__